import { IContainer } from "../types/container";

export const filterUniqueContainersById = (containers: IContainer[]): IContainer[] => {
  const seen = new Set<number>();
  return containers.filter((container) => {
    if (seen.has(container.containerId)) return false;
    seen.add(container.containerId);
    return true;
  });
};
